import script from "./QuotationPrintView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationPrintView.vue?vue&type=script&setup=true&lang=js"

import "./QuotationPrintView.vue?vue&type=style&index=0&id=2ebbc657&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebbc657"]])

export default __exports__